import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';

// Gestione errori di caricamento moduli (MIME type error)
window.addEventListener('error', (event) => {
  const isModuleError = event.message?.includes('Failed to load module script') ||
                        event.message?.includes('MIME type') ||
                        event.message?.includes('text/html');

  if (isModuleError) {
    console.error('⚠️ Errore caricamento modulo - Pulisco cache e ricarico...', event.message);

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then(registrations => {
        registrations.forEach(registration => registration.unregister());
      });

      if ('caches' in window) {
        caches.keys().then(names => {
          names.forEach(name => caches.delete(name));
        });
      }
    }

    setTimeout(() => {
      window.location.reload();
    }, 100);
  }
});

// Detector schermata bianca - ricarica se l'app non si è caricata entro 5 secondi
let appLoaded = false;

setTimeout(() => {
  if (!appLoaded) {
    const root = document.getElementById('root');
    const hasContent = root && root.children.length > 0;

    if (!hasContent) {
      console.warn('⚠️ App non caricata - ricarico...');
      window.location.reload();
    }
  }
}, 5000);

// Marca l'app come caricata dopo il render
setTimeout(() => {
  appLoaded = true;
}, 1000);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
